import styled from 'styled-components';

import MdIcon from '~/shared/components/mdIcon';

export const Container = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  min-height: fit-content;
  padding-bottom: 5rem;
  @media (min-width: 760px) {
    width: 420px;
    margin: 0 auto;
  }
  opacity: 1;
  animation: fadeInOpacity 250ms ease-in;
  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const HeaderContainer = styled.div`
  background: ${(props) => props.theme.palette.primary.main};
`;

export const IconClick = styled.div``;

export const Header = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-family: 'Rubik';
  text-align: center;
  padding: 20px;
  margin: 0 20px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.lightTransparency};
  @media (min-width: 760px) {
    min-width: 100%;
    margin: 0px;
  }
`;

export const PrescriptionBackgroundHeader = styled.div`
  width: 100%;
  content: ' ';
  background: ${(props) => props.theme.palette.primary.main};
  height: ${(props) => props.BackgroundHeight || 'unset'};
  margin-bottom: -${(props) => props.BackgroundHeight || 'unset'};
`;

export const Title = styled.div`
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  text-align: center;
  font-family: 'Rubik';
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0px;
  color: ${(props) => props.theme.palette.primary.contrastText};
  opacity: 1;
  padding: ${(props) => props.theme.spacing.small} 0px;
`;

export const NavContainer = styled.div`
  display: flex;
`;

export const OptionNav = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65px;
  background: ${(props) => props.theme.palette.primary.contrastText};
  text-align: center;
  font-size: 14px;
  font-family: 'RubikBold';
  font-weight: ${(props) => (props.isDisabled ? 600 : 'bold')};
  letter-spacing: 0px;
  color: ${(props) =>
    props.isDisabled ? props.theme.palette.gray3 : props.theme.palette.gray2};
  text-transform: uppercase;
  opacity: 1;
`;

export const StyledIcon = styled(MdIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const IconContainer = styled.div`
  position: absolute;
  left: 0;
  padding-left: 24px;
  cursor: pointer;

  @media (max-width: 320px) {
    padding-left: 0px;
  }
`;

export const PrescriptionNavContainer = styled.div`
  flex: 1;
`;

export const QrCodeNavContainer = styled.div`
  flex: 1;
`;

export const BorderBottom = styled.div`
  background-color: #fff;
  height: 3px;
  opacity: 0;
  transition: all 0.8s linear;

  ${(props) =>
    props.isDisabled
      ? `
    background-color: #2493EB;
    opacity: 1;
  `
      : ''}
`;

export const ExamList = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Button = styled.button`
  ${(props) => {
    let textColor = props.theme.palette.white;
    let backgroundColor = props.color
      ? props.color
      : props.theme.palette.primary.main;
    let borderColor = 'transparent';
    if (props.variant && props.variant === 'outlined') {
      backgroundColor = props.theme.palette.white;
      borderColor = props.color
        ? props.color
        : props.theme.palette.primary.main;
      textColor = props.color ? props.color : props.theme.palette.primary.main;
    }
    return {
      'background-color': backgroundColor,
      'border-color': borderColor,
      color: textColor,
    };
  }};
  border-width: 1px;
  border-style: solid;
  min-height: 50px;
  border-radius: 8px;
  font-weight: 500;
  margin: ${({ margin }) => margin};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActionArea = styled.div`
  width: ${({ width }) => width || '335px'};
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: 10px;
  margin-top: 10px;
  @media (max-width: 330px) {
    width: ${({ width }) => (width ? width - 30 : '305px')};
  }
`;

export const PdfContainer = styled.div`
  background: gray;
  display: flex;
  max-width: 100vw;
  height: auto;
  min-height: 1500px;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  margin-bottom: 200px;
  canvas {
    padding-top: 50px;
    padding-bottom: 100px;
    margin: 0 auto;
  }
`;

export const PdfNotFoundContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-top: 120px;
`;

export const NotFoundReaderPdfTitle = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.palette.primary.main};
  text-align: center;
  margin: 20px;
`;

export const NotFoundReaderPdfButton = styled.button`
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  bottom: 20px;
  max-width: 100%;
  height: 50px;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  width: 279px;
  text-align: center;
  font-weight: 600;
  color: ${(props) => props.theme.palette.primary.main};
  justify-content: center;
  align-content: center;
  align-self: center;
  background: ${(props) => props.theme.palette.primary.contrastText};

  a {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;
